import React from "react";
import { formatCentsAsDollars, parseCurrencyToCents } from "../../../util/formatters";
import { toNumber } from "lodash-es";

export const CptFeeScheduleByTestPricingDetails = ({ cptFeeScheduleByTest, cptContractedRates }) => {
  const hasCptCodes = cptFeeScheduleByTest?.cpt_codes?.length > 0;

  return (
    <>
      {cptFeeScheduleByTest.test_info.map(({ commercial_name, price_cents }) => (
        <li
          className="d-flex flex-row justify-content-between align-items-center mb-2"
          key={`fee-schedule-${commercial_name}`}
          id={`fee-schedule-${commercial_name}`}
        >
          <h5 className="text-muted fw-semibold">{commercial_name}</h5>
          <h5 className="text-dark fw-bold">{formatCentsAsDollars(price_cents)}</h5>
        </li>
      ))}

      {hasCptCodes &&
        cptFeeScheduleByTest.cpt_codes.map(({ code, multiplier }) => (
          <li
            className="d-flex flex-row justify-content-between align-items-center mb-2"
            key={`excluded-cpt-code-${code}`}
            id={`excluded-cpt-code-${code}`}
          >
            <h5 className="text-muted fw-semibold">
              {code} ( {cptRateFromContractedRates(cptContractedRates, code)} ) x {multiplier}
            </h5>
            <h5 className="text-dark fw-bold">{calculateTotalCptCost(cptRateFromContractedRates(cptContractedRates, code), multiplier)}</h5>
          </li>
        ))}
    </>
  );
};

const calculateTotalCptCost = (cptCodeCost, multiplier) => {
  return formatCentsAsDollars(parseCurrencyToCents(cptCodeCost) * toNumber(multiplier) || 0);
};

const cptRateFromContractedRates = (cptContractedRates, code) => {
  return formatCentsAsDollars(cptContractedRates?.[code]);
};
